(function () {
  let docListenersAttached = false;
  let savedScrollY = 0;
  let bodyScrollLocked = false;

  function lockBodyScroll() {
    if (bodyScrollLocked) return;
    bodyScrollLocked = true;
    savedScrollY = window.scrollY || document.documentElement.scrollTop;
    document.body.style.setProperty("position", "fixed");
    document.body.style.setProperty("top", `-${savedScrollY}px`);
    document.body.style.setProperty("left", "0");
    document.body.style.setProperty("right", "0");
    document.body.style.setProperty("width", "100%");

    const header = document.querySelector("x-header.header");
    if (header) {
      header.classList.remove("is-hidden");
      document.documentElement.style.setProperty("--header-is-visible", "1");
    }
  }

  function unlockBodyScroll() {
    if (!bodyScrollLocked) return;
    bodyScrollLocked = false;
    document.body.style.removeProperty("position");
    document.body.style.removeProperty("top");
    document.body.style.removeProperty("left");
    document.body.style.removeProperty("right");
    document.body.style.removeProperty("width");
    document.documentElement.style.removeProperty("--header-is-visible");
    window.scrollTo(0, savedScrollY);
  }

  // Arama panelini kapatma ve sınıfları temizleme
  function closeInlineSearch(wrapper) {
    const input = wrapper.querySelector('input[name="q"]');
    const slot = wrapper.querySelector('predictive-search [slot="results"]');
    
    if (!input) return;

    unlockBodyScroll();
    input.value = "";
    input.blur();
    if (slot) slot.innerHTML = "";
    
    // Sınıfları kaldır
    wrapper.classList.remove('header__search-inline--active');
    document.body.classList.remove('search-is-active');
  }

  // Arama durumuna göre Body ve Wrapper sınıflarını yönetme
  function toggleSearchState(wrapper, isActive) {
    if (isActive) {
      wrapper.classList.add('header__search-inline--active');
      document.body.classList.add('search-is-active');
    } else {
      wrapper.classList.remove('header__search-inline--active');
      document.body.classList.remove('search-is-active');
    }
  }

  function fixViewAllFormRefs(wrapper) {
    const form = wrapper.querySelector("form");
    const predictiveId = form?.getAttribute("aria-owns");
    if (!predictiveId) return;
    
    const predictive = document.getElementById(predictiveId);
    if (!predictive) return;

    const buttons = predictive.querySelectorAll('button[form="predictive-search-form"]');
    buttons.forEach(btn => btn.setAttribute("form", form.id));
  }

  function initInlineSearchPredictive() {
    const wrappers = document.querySelectorAll(
      ".header__search-inline--with-predictive:not([data-byte-inline-search-bound])"
    );

    wrappers.forEach(wrapper => {
      const input = wrapper.querySelector('input[name="q"]');
      const backdrop = wrapper.querySelector("[data-inline-search-backdrop]");
      const resultsDiv = wrapper.querySelector('[slot="results"]');

      wrapper.setAttribute("data-byte-inline-search-bound", "");

      // Yazı yazıldığında veya odaklanıldığında kontrol
      input.addEventListener('input', () => {
        toggleSearchState(wrapper, input.value.length > 0);
      });

      input.addEventListener('focus', () => {
        if (input.value.length > 0) toggleSearchState(wrapper, true);
      });

      // Backdrop tıklandığında kapat
      if (backdrop) {
        backdrop.addEventListener("click", () => closeInlineSearch(wrapper));
      }

      wrapper.addEventListener("focusin", () => {
        lockBodyScroll();
      });

      wrapper.addEventListener("focusout", (e) => {
        if (wrapper.contains(e.relatedTarget)) return;
        setTimeout(() => {
          if (!wrapper.contains(document.activeElement)) {
            unlockBodyScroll();
          }
        }, 0);
      });

      // MutationObserver: Sonuçlar değiştiğinde form referanslarını düzelt
      if (resultsDiv && window.MutationObserver) {
        const observer = new MutationObserver(() => fixViewAllFormRefs(wrapper));
        observer.observe(resultsDiv, { childList: true, subtree: true });
      }
    });

    if (!docListenersAttached) {
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          const activeWrapper = document.querySelector(".header__search-inline--active");
          if (activeWrapper) closeInlineSearch(activeWrapper);
        }
      });
      docListenersAttached = true;
    }
  }

  // Sayfa yüklendiğinde ve Shopify editöründe çalıştır
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initInlineSearchPredictive);
  } else {
    initInlineSearchPredictive();
  }

  document.addEventListener("shopify:section:load", initInlineSearchPredictive);
})();